import { useMutation } from '@tanstack/react-query';
import { PersonalSchedule } from '#types/schedule';
import { patch } from '../libs';

interface Payload extends PersonalSchedule {
  /** 스케줄 ID */
  id: string;
}

/**
 * 코치 - 개인일정 수정
 */
export function usePatchPersonalScheduleMutaion() {
  return useMutation(({ id, ...payload }: Payload) =>
    patch<string, Omit<Payload, 'id'>>(
      `/schedules/coach/personal/${id}`,
      payload
    )
  );
}
